/**
 * Selects an API endpoint based on the current user's audience
 * (internal employee, external vendor, or external customer).
 *
 * Precedence: internal > vendor > external.
 *
 * `vendor` is optional. If omitted (or `isVendor` is false), external is used
 * for any non-internal caller — preserving legacy 2-way (internal/external)
 * routing.
 */
export type EndpointVariants = {
	internal: string;
	external: string;
	vendor?: string;
};

export type Audience = {
	isInternal: boolean;
	isVendor?: boolean;
};

export const pickEndpoint = (
	routes: EndpointVariants,
	{ isInternal, isVendor = false }: Audience,
): string => {
	if (isInternal) {
		return routes.internal;
	}
	if (isVendor && routes.vendor != null) {
		return routes.vendor;
	}
	return routes.external;
};
